import React from 'react';

const Body = (props) => {
  return (
    <div className="container">
      {/*親要素に"row"というクラス名をつける*/}
      <div className = "row">
        {props.children}
      </div>
    </div>
  );
};

export default Body;



// WEBPACK FOOTER //
// ./src/components/Body/Body.js